import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecipesData } from "../../../redux/RecipesSlice";
import { LoaderWrap } from "../../../Component/GlobalLoader/LoaderWrap";
import "./Recipes.css";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import RecipesClose from "../../../Assets/Svg/Recipes/RecipesClose.svg";

export default function RecipesContent() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.recipes);

  useEffect(() => {
    if (!data || Object.keys(data).length === 0) {
      dispatch(fetchRecipesData({ lang: "en" }));
    }
  }, [dispatch, data]);

  const section1 = data?.section_id === "1" ? data : null;
  const recipes = data?.recipes || [];

  return (
    <>
      <LoaderWrap>
        <div className="RecipesContainer">
          <section>
            <RecipesS1 section1={section1} />
          </section>
          <section className="RecipesS2">
            <RecipesS2 recipes={recipes} />
          </section>
        </div>
      </LoaderWrap>
    </>
  );
}
function RecipesS1({ section1 }) {
  return (
    <>
      <div className="RecipesS1">
        <TC3L Head="Recipes" Title={section1?.title} Para={section1?.description} ParaWidth="56vw" ParaFSize="4.64vw" ParaWidthMob="89vw" />
      </div>
    </>
  );
}

function RecipesBox({ Time, Name, ImgSrc, ImgAlt, ImgClass, onClick }) {
  return (
    <div className="RecipesBox" onClick={onClick}>
      <div className="RecipesBoxP1">
        <div className="RBP1T TFut16PxPCUC">{Time}</div>
        <div className="RBP1N TFut24PxPC">{Name}</div>
      </div>
      <div className="RecipesBoxP2">
        <img src={ImgSrc} alt={ImgAlt} className={ImgClass} />
      </div>
    </div>
  );
}

function RecipesS2({ recipes }) {
  const [popupData, setPopupData] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleBoxClick = (recipe) => {
    const mapped = {
      Name: recipe.name,
      Time: recipe.preparation_time,
      ImgSrc: recipe.image,
      ImgAlt: recipe.name,
      Description: recipe.description,
      Url: recipe.video_id,
      Ingredients: recipe.ingredients || [],
    };
    setPopupData(mapped);
    setTimeout(() => setIsAnimating(true), 10);
  };

  const closePopup = useCallback(() => {
    setIsAnimating(false);
    setTimeout(() => setPopupData(null), 300);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closePopup();
      }
    };

    if (popupData) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [popupData, closePopup]);

  useEffect(() => {
    const handleScrollbar = () => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      if (popupData) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      } else {
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };

    handleScrollbar();

    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [popupData]);

  return (
    <>
      <div className="RecipesS2">
        {recipes.map((recipe, index) => (
          <RecipesBox
            key={index}
            Time={recipe.preparation_time}
            Name={recipe.name}
            ImgSrc={recipe.image}
            ImgAlt={recipe.name}
            onClick={() => handleBoxClick(recipe)}
          />
        ))}
      </div>

      {popupData && (
        <div className={`PopupOverlay ${popupData ? "show" : ""}`}>
          <div className={`PopupContent ${isAnimating ? "DropDownAnitmation" : ""}`}>
            <button className="CloseButton" onClick={closePopup}>
              <img src={RecipesClose} alt="" className="RecipesClose" />
            </button>
            <div className="PopupSection">
              <div className="RBP1N TFut24PxPC Recipe_S_N">{popupData.Name}</div>
            </div>
            <div className="PopUpVideo">
              <iframe src={`https://player.vimeo.com/video/${popupData.Url}`} frameBorder="0" allow="autoplay; fullscreen" allowFullScreen></iframe>
            </div>
            <div className="PopupSection">
              <div className="TFut24PxPC">Description</div>
              <div className="TF20PxSC popupDataDec">{popupData.Description}</div>
            </div>
            {Array.isArray(popupData.Ingredients) &&
              popupData.Ingredients.map((group, index) => (
                <div className="PopupSection" key={index}>
                  <div className="TFut24PxPC">{group.name}</div>
                  <div className="TF20PxSC popupDataDec">{group.item.join(", ")}</div>
                </div>
              ))}
            {popupData.Time && (
              <div className="PopupSection">
                <div className="TFut24PxPC">Preparation Time</div>
                <div className="RBP1T TFut16PxPCUC">{popupData.Time}</div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
